import { jwtDecode } from "jwt-decode";
// Base_url
// export const BASE_URL =
//   window.location.hostname === "localhost"
//     ? "https://localhost:92"
//     : "https://fieldsathi.com:92";

// export const BASE_URL = "http://127.0.0.1:8000";
// export const BASE_URL = "http://110.225.254.51:85"
export const BASE_URL = "https://fieldsathi.com:92";

export const HEADERS = {
  Authorization: `Bearer ${localStorage.getItem("token")}`,
};

export const getUserId = () => {
  const token = localStorage.getItem("token");
  if (token) {
    const decoded = jwtDecode(token);
    return decoded?.email;
  }
};

export const isToken = () => {
  const token = localStorage.getItem("token");
  if (token) {
    return true;
  }
  return false;
};

export const roleData = {
  admin: "admin",
  agent: "agent",
  customer: "customer",
  technician: "technician",
  sales: "sales",
  superuser: "superuser",
  subcustomer: "subcustomer",
  superadmin: "superadmin",
};


// src/constants/statusColors.js

export const STATUS_COLORS = {
  Accepted: "#6FCF97", 
  Rejected: "#EB5757", 
  Ongoing: "#F2C94C", 
  Completed: "#4A90E2", 
  "On-Hold": "#F2994A", 
  Inactive: "#BDBDBD", 
  Autoclose: "#9B51E0", 
  Default: "#828282", 
  Submitted: "#BDBDBD",
  Approved:"#6FCF97",
  Dispatched:"#4A90E2",
  Paid:"#4A90E2",
  Upcoming:"#F2C94C",
  Renewal:"#9B51E0",
  Expired:"#f9c2c2ff",
  "Not-Assigned":"#343a40",
  'Total AMC':"#ccf1cfff"
};

export const getStatusDotColor = (status) => {
  switch (status?.toLowerCase()) {
    case "present":
      return "#6FCF97"; 
    case "idle":
      return "#F2C94C"; 
    case "on leave":
      return "#9B51E0"; 
    case "absent":
      return "#EB5757"; 
    default:
      return "#6c757d"; 
  }
};
